


























































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Validations } from "vuelidate-property-decorators";
import { required, email } from "vuelidate/lib/validators";
import { phone } from "@/validators/custom";
import { Address } from "@/models/address/address";
import { NetSuiteCustomer } from "@/models/netsuite/netsuite";
import countries from "@/models/form/data";
import { EventBus } from "@/event-bus";
import FormValidation from "@/components/elements/form/FormValidation.vue";
import states from "@/models/form/state-abbrv";
import provinces from "@/models/form/prov-abbrv";

@Component({
  components: {
    FormValidation
  }
})
export default class Billing extends Vue {
  @Prop() addressee!: string;
  @Prop() attention!: string;
  @Prop() address!: Address;
  @Prop() phone!: string;
  @Prop() email!: string;
  @Prop({ default: null }) fullCustomer!: NetSuiteCustomer | null;
  @Prop({ default: true }) isNewCustomer!: boolean;
  @Prop({ default: null }) shippingDetails!: any;

  protected countries = countries;
  protected country = "";
  protected sameAsShipping = false;
  protected submitted = false;

  @Validations()
  validations() {
    if (this.hasBilltoData) {
      return {};
    }
    return {
      address: {
        address_1: { required },
        city: { required },
        state: {
          stateReq: value => {
            if (
              !value &&
              (this.address.country === "US" ||
                this.address.country === "Canada")
            ) {
              return false;
            } else {
              return true;
            }
          }
        },
        postal_code: { required },
        country: { required }
      },
      phone: { required, phone },
      email: { required, email }
    };
  }

  get hasBilltoData(): boolean {
    return !!(
      this.fullCustomer &&
      (this.fullCustomer.billtoaddress1 ||
        this.fullCustomer.billtocity ||
        this.fullCustomer.billtozip)
    );
  }

  get states(): string[] {
    let list = ["--"];
    if (this.country === "Canada") {
      list = provinces;
    } else if (this.country === "US") {
      list = states;
    }
    return list;
  }

  beforeDestroy() {
    EventBus.$off("submitCheckoutForm");
  }

  @Watch("$v.$invalid", { deep: true })
  onFormChange(): void {
    if (this.submitted) {
      this.validateForm();
    }
  }

  @Watch("country")
  public updateCountry() {
    const newAddress = Object.assign(
      {},
      { ...this.address },
      { country: this.country }
    );
    this.$emit(`update:address`, newAddress);
    if (this.submitted && this.$v.address["country"]) {
      this.$v.address["country"]!.$touch();
    }
    if (this.country !== "US" && this.country !== "Canada") {
      this.updateAddress({ state: "" }, "state");
    }
  }

  created() {
    EventBus.$on("submitCheckoutForm", this.validateForm);
    this.country = this.address.country ? this.address.country : "US";
    if (this.hasBilltoData) {
      this.$emit("sendError", false, "billing");
    }
  }

  @Watch("address.country")
  onAddressCountryChanged(val: string): void {
    if (val && val !== this.country) {
      this.country = val;
    }
  }

  @Watch("fullCustomer")
  onFullCustomerLoaded(): void {
    if (!this.hasBilltoData || !this.fullCustomer) return;
    const fc = this.fullCustomer;
    if (fc.billtoaddressee && !this.addressee)
      this.updateItem(fc.billtoaddressee, "addressee");
    if (fc.billtoattention && !this.attention)
      this.updateItem(fc.billtoattention, "attention");
    if (fc.invoice_email && !this.email)
      this.updateItem(fc.invoice_email, "email");
    if (fc.phone && !this.phone) this.updateItem(fc.phone, "phone");
    if (fc.billtocountry) this.country = fc.billtocountry;
    // Batch all address fields into one emit to avoid each call overwriting the previous
    const newAddress = Object.assign(
      {},
      { ...this.address, country: this.country }
    );
    if (fc.billtoaddress1 && !this.address.address_1)
      newAddress.address_1 = fc.billtoaddress1;
    if (fc.billtoaddress2) newAddress.address_2 = fc.billtoaddress2;
    if (fc.billtoaddress3) newAddress.address_3 = fc.billtoaddress3;
    if (fc.billtocity && !this.address.city) newAddress.city = fc.billtocity;
    if (fc.billtostate && !this.address.state)
      newAddress.state = fc.billtostate;
    if (fc.billtozip && !this.address.postal_code)
      newAddress.postal_code = fc.billtozip;
    if (fc.billtocountry) newAddress.country = fc.billtocountry;
    this.$emit("update:address", newAddress);
  }

  protected validateForm(): void {
    this.submitted = true;
    this.$v.$touch();
    this.$emit("sendError", this.$v.$invalid, "billing");
  }

  /**
   * Have to explicitly call vuelidate ($v) methods if not using v-model
   */
  public updateItem(fieldValue: string, fieldName: string) {
    this.$emit(`update:${fieldName}`, fieldValue);
    if (this.submitted && this.$v[fieldName]) {
      this.$v[fieldName]!.$touch();
      this.validateForm();
    }
  }

  /**
   * Cannot update a nested property in an object due to the way Vue tracks nested data
   * i.e. update:address.address_1 = value will not trigger reactivity, so use Object.assign{} and update entire address object
   */
  public updateAddress(newObj: any, fieldName: string) {
    const newAddress = Object.assign(
      {},
      { ...this.address, country: this.country },
      { ...newObj }
    );
    this.$emit(`update:address`, newAddress);
    if (this.submitted && this.$v.address[fieldName]) {
      this.$v.address[fieldName]!.$touch();
      this.validateForm();
    }
  }
}
